import type { ReactElement } from 'react';
import { cloneElement } from 'react';
import type { Disabled } from 'components/dataCreationForms/withInputForm/statefulInputsWrapper/types';
import type { SxProps, Theme } from '@mui/material';
import { editorHostSx, compactRichTextSx } from './styles';
import { InspectionCommentLabelVariant } from './types';

export const INSPECTION_COMMENT_FORMAT_TOOLBAR_TOGGLE_QA =
  'inspection-comment-format-toolbar-toggle';
export const INSPECTION_COMMENT_LABEL_QA = 'inspection-comment-label';
export const TEMPLATE_COMMENT_FORMAT_TOOLBAR_TOGGLE_QA =
  'template-comment-format-toolbar-toggle';

export function isFloatingCommentLabel(
  labelVariant: InspectionCommentLabelVariant
): boolean {
  return labelVariant === InspectionCommentLabelVariant.floating;
}

export type CollapsibleRichTextChildProps = {
  minRows?: number;
  autoGrow?: boolean;
};

export function isCommentLocked(disabled: Disabled | undefined): boolean {
  return disabled === true || (typeof disabled === 'object' && disabled !== null);
}

export function resolveCommentValue(
  formValue: unknown,
  fallbackValue: string
): string {
  return typeof formValue === 'string' ? formValue : fallbackValue;
}

export function withCollapsibleRichTextDefaults(
  children: ReactElement
): ReactElement {
  return cloneElement(children, {
    minRows: 1,
    autoGrow: true,
  });
}

export function getEditorHostSx(
  compactSingleLineLayout: boolean,
  formatToolbarOpen: boolean
): SxProps<Theme> {
  return [
    editorHostSx,
    compactRichTextSx(compactSingleLineLayout, formatToolbarOpen),
  ] as SxProps<Theme>;
}
